import React from "react";
import Icon from "../Icon";
import styles from "./CopyButton.module.sass";
import { Tooltip } from 'antd';

const CopyButton = ({text}) => {

    const copyToClipboard = (text) => {
        return navigator.clipboard.writeText(text);
    };

    return (
      <Tooltip title="copied!" color="blue" trigger="click">
        <button className={styles.copy} onClick={() => copyToClipboard(text)}>
          <Icon name="copy" size="16"/>
        </button>
      </Tooltip>
    );
}

export default CopyButton;